
export const SET_SELECTION = 'SET_SELECTION';
export const CLEAN_SELECTION = 'CLEAN_SELECTION';

export const setSelection = (data) => ({
   type: SET_SELECTION,
   payload: data
});

export const cleanSelection = () => ({
   type: CLEAN_SELECTION
});




// WEBPACK FOOTER //
// ./src/actions/selectSuggestionActions.js